// Cart Event System
// This file contains utility functions for cart operations

/**
 * Notifies components that an item has been added to the cart
 * Dispatches a custom event that can be listened to by components
 * @param {Object} item - The item that was added to the cart (optional)
 */
export const notifyCartItemAdded = (item = null) => {
  // Create and dispatch a custom event
  const event = new CustomEvent('cartItemAdded', {
    detail: { item, timestamp: new Date().getTime() },
  });
  window.dispatchEvent(event);

  // Also trigger the cart bubble refresh event
  refreshCartBubble();
};

/**
 * Notifies components that cart items have been removed
 * Dispatches a custom event that can be listened to by components
 * @param {Array} itemIds - The IDs of items that were removed (optional)
 */
export const notifyCartItemsRemoved = (itemIds = []) => {
  // Create and dispatch a custom event
  const event = new CustomEvent('cartItemsRemoved', {
    detail: { itemIds, timestamp: new Date().getTime() },
  });
  window.dispatchEvent(event);

  // Also trigger the cart bubble refresh event
  refreshCartBubble();
};

/**
 * Notifies components that an order has been placed
 * Dispatches a custom event that can be listened to by components
 */
export const notifyOrderPlaced = () => {
  // Create and dispatch a custom event
  const event = new CustomEvent('orderPlaced', {
    detail: { timestamp: new Date().getTime() },
  });
  window.dispatchEvent(event);

  // Also trigger the cart bubble refresh event
  refreshCartBubble();
};

/**
 * Triggers a refresh of the cart bubble content
 */
export const refreshCartBubble = () => {
  // Create and dispatch the custom event for refreshing the cart
  const event = new CustomEvent('refreshCartBubble', {
    detail: { timestamp: new Date().getTime() },
  });
  window.dispatchEvent(event);
};
